import { Observable, throwError } from 'rxjs';
import { EventEmitter, Injectable } from '@angular/core';
import { AccessTokenData, AccountTypeEnum, Auth0OrighinEnum, CareerProcessTypeEnum, DateData, OrgDataUpdateComparison, OrgDataUpdateReport, OrgDataUpdateRun, PersonalUserData, ResellerData, ResellerTokesStatusData, ResellerTokesStatusData_String, UserAlert, UserAuth0RedactedData, UserCreatedOrgData, UserCVMetadata, UserMinimalData } from './personal-user-data';
import { HttpClient, HttpRequest, HttpResponse } from '@angular/common/http';
import { UserCompetenciesData } from '../chat/strcutredProcess-data';
@Injectable({
  providedIn: 'root'
})
export abstract class AbstractPersonalUserDataService {

  abstract getResetUserPasswordUrl(): string;

  abstract getUnsubscribeUrl(): string;

  abstract getVerifyFeatureUrl(): string;

  abstract isUserLoggedIn(): boolean;

  abstract getLoggedInUserPersonalData(): PersonalUserData | undefined;

  abstract getUserLocale(): string;

  abstract logout(): void;

  abstract personalilze(): void;

  abstract getUserDetails(userId: string): Observable<PersonalUserData>;

  abstract getMinimalUserDetails(userId: string): Observable<UserMinimalData>;

  abstract approvePrivacyPolicy(): Observable<any>;

  abstract getUserImage(userId: string): Observable<ArrayBuffer>;

  abstract getUserInsightsReport(): Observable<ArrayBuffer>;
 
  abstract setLocale(overrideLocale : string) : void;

  abstract setUserDetails (locale: string, gender: number, phoneNumber: string, phoneNumberCountryCode:string, presentFullHierarchy:boolean, engagementLevel: number, preferredEngagementCahnnel: number, shouldGetQuestioner : boolean, allowShareMotivations: boolean, allowShareCalendar: boolean): Observable<string>;
  
  abstract updateUserPassword (oldPassword: string, newPassword: string): Observable<HttpResponse<string>>;

  abstract resetUserPassword (userMail: string): Observable<string>;
  
  abstract unsubscribeMail (userMail: string, unsubscribeType: string): Observable<string>;

  abstract setRelationship (counterpartId: string, costOfSeperation: number, chanceOfSeperation: number): Observable<string>;

  abstract isMissingRelationship (counterpartId: string): Observable<boolean>;

  abstract sendDiscoveryReminder (counterpartId: string): Observable<string>;

  abstract getAlertsForCounterpart (counterpartId: string): Observable<UserAlert[]>;

  abstract shouldSkipRelationshipQuestion(userId: string, counterpartId: string): boolean;

  abstract postponeRelationshipsQuestion(userId:string, counterpartId: string):void;

  abstract getSelfResellerData (): Observable<ResellerData>;

  abstract getResellerUsageReport(usersList: string): Observable<ArrayBuffer> ;

  abstract reallocateAccessTokenByAmount(resllerMail: string, tokensAmount:number, accountType: AccountTypeEnum, careerProcessType: CareerProcessTypeEnum): Observable<AccessTokenData[]>;
   
  abstract reallocateSpecificAccessToken(resllerMail: string, specificTokensList:string): Observable<string[]>;

  abstract verifyFeature(featureId: string) : Observable<boolean>;

  abstract getDiscoveryProcessEndDate() : Observable<DateData>;

  abstract getResellerTokensStatus() : Observable<ResellerTokesStatusData_String>;

  abstract getResellerActiveTokensForOrg(orgId: string): Observable<AccessTokenData[]>;

  abstract getAllUserCreatedOrgs(userIdOverride? : string): Observable<UserCreatedOrgData[]>;

  abstract createOrgByUser(name: string, description:string) : Observable<string>;

  abstract editOrgDetails(orgId: string, name: string, description: string) : Observable<string>;

  abstract deleteOrg(orgId:string) : Observable<string>;

  abstract allocateTokensToGroup(orgId: string, tokensNo: number, accountType: AccountTypeEnum, careerProcessType: CareerProcessTypeEnum) : Observable<AccessTokenData[]>;

  abstract adminChangeParentToUsers(parentMail: string, subordinatesList: string): Observable<string[]>;

  abstract adminChangeOrgToUsers(orgId: string, usersList: string): Observable<string[]>;

  abstract adminConvertUserToReseller(userMail:string): Observable<string>;

  abstract adminSetExpirationDateToOrg(orgId:string, expirationDate: Date): Observable<string>;

  abstract verifyPhoneNumber_stage1(): Observable<string>;

  abstract verifyPhoneNumber_stage2(code: string): Observable<boolean>;

  abstract uploadCV(file: File): Observable<string>;

  abstract getUserCVMetadata(): Observable<UserCVMetadata | undefined>;

  abstract getUserAuth0RedactedData(origin: Auth0OrighinEnum): Observable<UserAuth0RedactedData | undefined>;

  abstract updateUserAuth0Details(userUPN: string, origin: Auth0OrighinEnum, accessToken: string, idToken: string): Observable<string>;

  abstract deleteUserAuth0Details(origin: Auth0OrighinEnum): Observable<string>;

  abstract adminGetLastOrgDataUpdateReport(orgId: string): Observable<OrgDataUpdateReport>;  

  abstract adminPreviewOrgDataUpdate(orgId: string): Observable<OrgDataUpdateRun>;

  abstract adminApplyOrgDataUpdate(orgId: string, runId: string): Observable<OrgDataUpdateRun>;

  abstract adminGetOrgDataUpdateRuns(orgId: string, limit?: number): Observable<OrgDataUpdateRun[]>;

  abstract adminGetOrgDataUpdateRun(orgId: string, runId: string): Observable<OrgDataUpdateRun>;

  abstract adminCompareOrgDataUpdateRuns(orgId: string, fromRunId: string, toRunId: string): Observable<OrgDataUpdateComparison>;

  abstract setUserCompetencies(userCompetencies: UserCompetenciesData): Observable<string>;

  abstract getUserCompetencies(): Observable<UserCompetenciesData | null>;

  abstract adminForcePassword(userMail: string, newPassword: string): Observable<string>;
}
